import { IconButton, skinVars } from '@telefonica/mistica';
import React, { useEffect, useState } from 'react';
import ChatText from '../ChatText';
import './index.scss';
import BrandLogo from '../../assets/images/BrandLogo.svg';

export interface ChatSupportData {
    text: any;
    html?: boolean;
}

export const ChatSupport: React.FC<ChatSupportData> = ({ text, html = false }: ChatSupportData) => {
    const [windowWidth, setWindowWidth] = useState<any>(window.innerWidth);

    useEffect(() => {
        const handleResize = () => {
            setWindowWidth(window.innerWidth);
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return (
        <div className='chatSupport'>
            <IconButton
                className='chatSupport__icon'
                style={{ marginRight: '8px' }}
                icon={BrandLogo}
                size={windowWidth >= 1024 ? 32 : 24}
                iconSize={windowWidth >= 1024 ? 16 : 10}
                backgroundColor={skinVars.colors.brand}
            />
            <ChatText context={'answer'} text={text} html={html}></ChatText>
        </div>
    );
};

export default ChatSupport;
